import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { AddressService } from '../../services/address.service';
import { CountryService } from '../../services/country.service';
import { StateService } from '../../services/state.service';
import { Globals } from '../../globals';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { PayrollId } from '../../services/catalogs-settings.service';
import { toast } from 'angular2-materialize';
import { Utils } from '../../util';

function notRequiredEmailValidator(control: FormControl) {
	if (!control.value) {
		return null;
	}

	return Validators.email(control);
}

@Component({
	selector: 'app-create-address',
	templateUrl: './create-address.component.html',
	styleUrls: ['./create-address.component.css', '../../app.component.css']
})

export class CreateAddressComponent implements OnInit {

	parent: string;
	customerOrSupplier: string;

	addressForm: FormGroup;
	address: any = [];
	
  routeSub: Subscription;

	id: string;

	countries: any[] = [];
	@Input() countryInit: string;
	@Output() countryModelChange = new EventEmitter();

	states: any[] = [];
	@Input() stateInit: string;
	@Output() stateModelChange = new EventEmitter();

	localitys: {name: string, value: string}[] = Object.keys(Globals.LOCALITYS).map(lockKey => ({name: `${lockKey}, ${Globals.LOCALITYS[lockKey].state}`, value: lockKey})).sort((a, b) => a.name > b.name ? 1 : -1);
	locality: string = '';

	municipilatys: {name: string, value: string}[] = Object.keys(Globals.MUNICIPALITYS).map(munKey => ({name: `${munKey}, ${Globals.MUNICIPALITYS[munKey].state}`, value: munKey})).sort((a,b) => a.name > b.name ? 1 : -1);
	municipality: string = '';

	requiresCartaPorte: boolean = false;

	constructor(
		private formBuilder: FormBuilder,
			private router: Router,
			private activatedRoute: ActivatedRoute,
			private addressService: AddressService,
			private countryService: CountryService,
			private stateService: StateService,
			private fsService: FirestoreService,
		) {

			this.parent = this.activatedRoute.parent.snapshot.paramMap.get('id');
			this.customerOrSupplier = this.activatedRoute.parent.snapshot.data['customerOrSupplier'];
			this.loadCountriesAndStates();
	}

	ngOnInit() {
		this.addressForm = this.formBuilder.group({
			street: ['', Validators.required],
			neighborhood: ['', Validators.required],
			externalNumber: ['', Validators.required],
			internalNumber: '',
			city: '',
			municipality: '',
			state: ['', Validators.required],
			country: ['', Validators.required],
			zipCode: ['', Validators.required],
			mobile: '',
			email: ['', notRequiredEmailValidator],
			email2: ['', notRequiredEmailValidator],
			phone: '',
			phone2: '',
		});
	}

	async onSubmitAddress() {
		try{
			this.address = this.saveAddress();
			let settings = await this.fsService.docWithId<PayrollId>(`${Globals.CATALOGS_SETTINGS}/1`);
			if(!settings) throw console.log('Settings get error');
			settings.folios.address++;
			this.address.folio = `DE${Utils.String.fillLeft(`${settings.folios.address}`, '0', 6)}`;
			await this.fsService.update(`${Globals.CATALOGS_SETTINGS}/1`, {folios: settings.folios});
			console.log('Se actualizó el folio.');
			this.address.xlocality = this.locality;
			this.address.xmunicipality = this.municipality;
			this.address.requiresCartaPorte = this.requiresCartaPorte;
	
			this.addressService.addAddress(this.address);
			this.addressForm.reset();
			
			if(this.customerOrSupplier == 'customerId'){
				this.router.navigate(['/vw_customer/' + this.parent + '/addresses']);
			}else if(this.customerOrSupplier == 'supplierId'){
				this.router.navigate(['/vw_supplier/' + this.parent + '/addresses']);
			}
		}catch(error){
			toast('Error al crear dirección.', 2000);
		}
	}

	saveAddress() {
		var customerId = '';
		var supplierId = '';
		if(this.customerOrSupplier == 'customerId') {
			customerId = this.parent;
		} else if (this.customerOrSupplier == 'supplierId'){
			supplierId = this.parent;
		}

		const addressJson = {
			street: this.addressForm.get('street').value,
			city: this.addressForm.get('city').value,
			countryId: this.addressForm.get('country').value,
			municipality: this.addressForm.get('municipality').value,
			customerId: customerId,
			supplierId: supplierId,
			email: this.addressForm.get('email').value,
			email2: this.addressForm.get('email2').value,
			externalNumber: this.addressForm.get('externalNumber').value,
			internalNumber: this.addressForm.get('internalNumber').value,
			mobile: this.addressForm.get('mobile').value,
			neighborhood: this.addressForm.get('neighborhood').value,
			phone: this.addressForm.get('phone').value,
			phone2: this.addressForm.get('phone2').value,
			stateId: this.addressForm.get('state').value,
			typeId: 1,
			zipCode: this.addressForm.get('zipCode').value
		};

		return addressJson;
	}

	loadCountriesAndStates() {
		this.countries = Object.keys(Globals.COUNTRIES).map(key => ({id$: key, name: Globals.COUNTRIES[key].name}) );
		this.countryInit = '1';
		this.states = Object.keys(Globals.STATES).map(key => ({id$: key, name: Globals.STATES[key].name}) );
		this.stateInit = '1';
	}
	
	getBack() {
		if(this.customerOrSupplier == 'customerId'){
			this.router.navigate(['/vw_customer/' + this.parent + '/addresses']);
		} else if(this.customerOrSupplier == 'supplierId'){
			this.router.navigate(['/vw_supplier/' + this.parent + '/addresses']);
		}
	}

	changeCountry(countryValue) {
		this.countryModelChange.emit(countryValue);
	}

	changeState(stateValue) {
		this.stateModelChange.emit(stateValue);
	}

}